import React from 'react';
import Container from 'container';
import Headline from 'headline';
import ArticleCard from 'shared/article-card';

import s from './article_group_3.module.scss';

const article = {
  title: 'This is the article title',
  date: '2019-05-23T18:38:10',
  image: 'placeholder',
  excerpt: `
    <p>
    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Exercitationem
    ab aliquid accusantium molestiae temporibus in, inventore est nam veniam
    quia neque vel voluptates reiciendis eos alias accusamus id nemo quam
    fugiat porro consectetur nesciunt. Et fuga culpa dolore! Modi reiciendis
    aliquid nostrum illo doloribus reprehenderit eveniet laboriosam blanditiis
    in, accusamus, natus nemo maxime iure, voluptatem ipsum? Odio
  </p>`,
  categories: ['travel'],
  author: 'Joseph Casanova',
  editor: 'Elizabeth Williams',
  illustrator: 'Alexis Michaud'
};

const defaultArticles = Array(3)
  .fill(article)
  .map((article, i) => ({ ...article, title: `${article.title}${i}` }));

export default function ArticleGroup1({
  articles = defaultArticles,
  title = '<h4>headline title</h4>'
}) {
  return (
    <Container className={s.root}>
      <div className={s.wrapper}>
        <div className={s.cards}>
          {articles.map(card => (
            <ArticleCard
              {...card}
              key={card.title}
              className={s.card}
              horizontal
            />
          ))}
        </div>
      </div>
    </Container>
  );
}
